import React from 'react';
import { toast } from 'react-toastify';
import Button from '../_custom/Button/Button';
import { GREEN_BG_WHITE_TICK_CIRCLE, crossBtnGrey, whiteArrowTilted } from '../../assets/hostedassets';
import tooltipStyles from '../PersistentConfigToolTip/PersistentConfigToolTip.module.scss';
import styles from './addedToReportsToast.module.scss';

const AddedToReportsToastCard: React.FC<{ onView: () => void; closeToast?: () => void }> = ({ onView, closeToast }) => (
    <div
        className={`${tooltipStyles.tooltipContent} ${styles.card}`}
        style={{ width: '100%', boxSizing: 'border-box', maxWidth: 'calc(100vw - 2rem)' }}
    >
        <button type="button" className={tooltipStyles.closeButton} onClick={() => closeToast?.()} aria-label="Close">
            <img src={crossBtnGrey} alt="" />
        </button>
        <div style={{ display: 'flex', alignItems: 'start', gap: '0.5rem' }}>
            <img src={GREEN_BG_WHITE_TICK_CIRCLE} alt="" aria-hidden="true" style={{ height: '2rem', width: '2rem' }} />
            <div>
                <h3 className={tooltipStyles.tooltipHeading}>Successfully added to reports</h3>
                <p className={tooltipStyles.tooltipMessage}>This file is now available in the Reports section.</p>
            </div>
        </div>
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                width: '100%',
                marginTop: '1rem',
                justifyContent: 'end',
                gap: '0.5rem',
            }}
        >
            <Button text="Dismiss" variant="secondary" size="small" style={{ margin: 0 }} onClick={() => closeToast?.()} />
            <Button
                text="View Report"
                variant="primary"
                size="small"
                icon={whiteArrowTilted}
                iconStyles={{ marginRight: '0.5rem', height: '1rem' }}
                style={{ margin: 0 }}
                onClick={() => {
                    onView();
                    closeToast?.();
                }}
            />
        </div>
    </div>
);

export const showAddedToReportsToast = (onView: () => void, onClose?: () => void) => {
    toast.success(({ closeToast }: { closeToast?: () => void }) => <AddedToReportsToastCard onView={onView} closeToast={closeToast} />, {
        icon: false,
        closeButton: false,
        className: styles.toastReset,
        onClose,
    });
};
